import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UploadStatus } from '../../interfaces/upload/IUpload';
import { UploadProgressStepState, UploadProgressItem } from '../../interfaces/upload/upload-progress.interface';
import { UploadProgressOperations } from '../../operations/upload-progress.operations';
import { UploadProgressService } from '../../services/upload-progress.service';

@Component({
  selector: 'app-upload-progress-overlay',
  templateUrl: './upload-progress-overlay.component.html',
  styleUrls: ['./upload-progress-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class UploadProgressOverlayComponent {
  private readonly uploadProgressService = inject(UploadProgressService);

  protected readonly uploads = this.uploadProgressService.uploads;
  protected readonly activeUploadCount = computed(
    () => this.uploads().filter(upload => !UploadProgressOperations.isTerminalStatus(upload.status)).length,
  );

  protected getStatusLabelKey(status: UploadStatus): string {
    return UploadProgressOperations.getStatusLabelKey(status);
  }

  protected getStepStates(status: UploadStatus): UploadProgressStepState[] {
    return UploadProgressOperations.getStepStates(status);
  }

  protected dismissUpload(uploadId: string): void {
    this.uploadProgressService.dismissUpload(uploadId);
  }

  protected isTerminal(status: UploadStatus): boolean {
    return UploadProgressOperations.isTerminalStatus(status);
  }

  protected isError(status: UploadStatus): boolean {
    return UploadProgressOperations.isErrorStatus(status);
  }

  protected trackByUploadId(_: number, upload: UploadProgressItem): string {
    return upload.uploadId;
  }
}
